import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { Card, Dropdown, ListGroup } from 'react-bootstrap';

import FalconCardHeader from 'components/common/FalconCardHeader';
import Notification from 'components/notification/Notification';
import { getNotificationAlert } from 'functions/notification';
import { timeElapsed } from 'components/shared/shared';
const API = process.env.REACT_APP_API_PATH;
import {socket} from '../../../web_socket/socket'
import { useSelector } from 'react-redux';

const NotificationDropdown = () => {

  const [isOpen, setIsOpen] = useState(false);
  const [isAllRead, setIsAllRead] = useState(false);

  // Handler
  const handleToggle = () => {
    setIsOpen(!isOpen);
  };
  const [loadNotification,setLoadNotification]=useState(false);

  const [notificationNew,setNotificationNew]=useState(null);
  const { notiAction } = useSelector((state) => state.notification);
   
  useEffect(() => {
    window.addEventListener('scroll', () => {
      window.innerWidth < 1200 && setIsOpen(false);
    });
  }, []);

  
  useEffect(() => {
    joinRoom('notification');
  }, []);

   const joinRoom=(room)=>{
    if(room!==""){
      socket.emit('join_room',room)
    }
  
  }



  
  useEffect(() => {
    console.log('notification was loaded.')
    loadNotificationNew();
  }, [loadNotification]);





  useEffect(() => {
    socket.on("receive_action", data => {
      console.log('receive_action triggerd notification');
     // if(data.action==="replyConversation"){
      loadNotificationNew();
     //  setLoadNotification(!loadNotification);
    //  }
  
    });
  }, []);




  

   

  const loadNotificationNew= async()=>{
    const token = localStorage.getItem('token');
   const notification=await getNotificationAlert("new",token);

   const notificationNew=[];
        
   for(let i=0;i<notification.length;i++){

const n=notification[i];
    const obj=  {
      id: n.MessageId,
      avatar: {
        src: `${API}/file/image/${n.ProfilePic}`,
        size: '2xl'
      },
      children:
`<strong>${n.TicketNumber}</strong> | From <strong>${n.DisplayName} </strong>
<br/> ${n.lastDescription}`,
      time: timeElapsed(n.CreatedDate_UTC),
      emoji: '⏰',
      className: 'rounded-0 border-x-0 border-300 border-bottom-0',
      to: `/support-desk/tickets-preview/${n.TicketMasterId}`,
      unread: true
    }
    notificationNew.push(obj);
   }
 

   setNotificationNew(notificationNew);
  }



  const markAsRead = e => {
    e.preventDefault();

    const updatedNewNotifications = newNotifications.map(notification =>
      Object.prototype.hasOwnProperty.call(notification, 'unread')
        ? { ...notification, unread: false }
        : notification
    );
    const updatedEarlierNotifications = earlierNotifications.map(notification =>
      Object.prototype.hasOwnProperty.call(notification, 'unread')
        ? { ...notification, unread: false }
        : notification
    );

    setIsAllRead(true);
    setNewNotifications(updatedNewNotifications);
    setEarlierNotifications(updatedEarlierNotifications);
  };

  const containerStyle = {
    position: 'relative',
    display: 'inline-block',
  };
  
  const circleStyle = {
    width: '32px',
    height: '20px',
    backgroundColor: '#ff0303',
    borderRadius: '50%',
    position: 'absolute',
    top: '-5',
    left: '0',
    color:'white',
    zIndex:2
  };
  
  const iconStyle = {
    position: 'relative',
    zIndex: '1',
  };

  function RedCircleWithBellIcon(notifications) {
    return (
      <div style={containerStyle}>
      {notifications && notifications.length>0 &&  <div style={circleStyle}><span style={{paddingLeft:'5px'}}>{notifications.length}</span></div>}
            <FontAwesomeIcon icon="bell" transform="shrink-6" className="fs-4" style={iconStyle} />
      </div>
    );
  }
  
  return (
    <Dropdown navbar={true} as="li" show={isOpen}  onToggle={handleToggle}>
      <Dropdown.Toggle
        bsPrefix="toggle"
        as={Link}
        to="#!"
        className={classNames('px-0 nav-link')}
        // className={classNames('px-0 nav-link', {
        //   'notification-indicator notification-indicator-danger': !isAllRead
        // })}
      >
          {/* <FontAwesomeIcon icon="bell" transform="shrink-6" className="fs-4" /> */}
          
          {RedCircleWithBellIcon(notificationNew)}
      </Dropdown.Toggle>

      <Dropdown.Menu className="dropdown-menu-card dropdown-menu-end dropdown-caret dropdown-caret-bg">
        <Card
          className="dropdown-menu-notification dropdown-menu-end shadow-none"
          style={{ maxWidth: '20rem' }}
        >
          <FalconCardHeader
            className="card-header"
            title="Notifications"
            titleTag="h6"
            light={false}
            endEl={
              <Link
                className="card-link fw-normal"
                to="#!"
                onClick={markAsRead}
              >
                Mark all as read
              </Link>
            }
          />
          <ListGroup
            variant="flush"
            className="fw-normal fs--1 scrollbar"
            style={{ maxHeight: '19rem' }}
          >
            <div className="list-group-title">NEW</div>{' '}
            {notificationNew &&
              notificationNew.map(notification => {



              return  <ListGroup.Item key={notification.id} onClick={handleToggle}>
                  <Notification {...notification} flush />
                </ListGroup.Item>
              }
              
              )}
            {/* <div className="list-group-title">EARLIER</div>
            {isIterableArray(earlierNotifications) &&
              earlierNotifications.map(notification => (
                <ListGroup.Item key={notification.id} onClick={handleToggle}>
                  <Notification {...notification} flush />
                </ListGroup.Item>
              ))} */}
          </ListGroup>
          <div
            className="card-footer text-center border-top"
            onClick={handleToggle}
          >
            <Link className="card-link d-block" to="#!">
              View all
            </Link>
          </div>
        </Card>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default NotificationDropdown;
